/** Тип документа или документ с настройкой «Запрет доступа к типу документа» (id ролей через запятую) */
interface IWithBlockAccess {
  blockAccessToDocumentType?: string;
}

export function validatingDocWithRole<T extends IWithBlockAccess>(documentTypes: T[], currentRole: number): T[] {
  if (!currentRole || !documentTypes.length) {
    return documentTypes;
  }
  const pattern = new RegExp(`(^|,)${currentRole}(,|$)`);
  return documentTypes.filter((d: T) => {
    return !d.blockAccessToDocumentType ? true : !pattern.test(d.blockAccessToDocumentType);
  });
}

import { IFile } from '@/types/docTypes';

export function getColorEDSignature(file: IFile): string {
  return file.doc.signCheckResultsEcp.some((cert) => !cert.valid || cert.vicarious?.valid === false)
    ? 'error'
    : 'green';
}
